export default function ismobileviewport () {
  return $('.sitenavbar__toggle').is(':visible')
}
